<script setup lang="ts">
import { computed, ref } from "vue";
import FormPanel from "@/components/forms/SharedComponents/panel.vue";
import RemindersList from "@/components/MyExperiences/MyExperienceDetail/Reminders/RemindersList.vue";
import type { RemindersSectionProps } from "@/components/MyExperiences/MyExperienceDetail/Reminders/types.ts";
import BellIcon from "@/components/shared/icons/BellIcon.vue";
import { ORDER_STATUS } from "@/constants.ts";

const props = defineProps<RemindersSectionProps>();
const panelExpanded = ref<boolean>(true);
const remindersCount = ref<number>(0);

const setExpanded = (expanded: boolean): void => {
  panelExpanded.value = expanded;
};

const setRemindersCount = (count: number): void => {
  remindersCount.value = count;
};

const showReminders = computed(() => {
  return props.orderStatus !== ORDER_STATUS.withdrawn && remindersCount.value > 0;
});
</script>

<template>
  <FormPanel
    :id="'reminders'"
    :initially-expanded="panelExpanded"
    v-show="showReminders"
    main-panel-class="bg-white sm:rounded-lg sm:shadow-md"
    panel-content-class="border-b border-gray-200 px-4"
    panel-button-text-class="capitalize xs:tracking-normal"
    main-header-class="capitalize py-4 px-8 border-none"
    data-testid="reminders-section"
    @panel-expanded-event="setExpanded">
    <template #titleText>
      <div class="flex flex-row items-center font-indigo-base">
        <BellIcon />
        <span class="ml-2">
          Reminders & Updates ({{ remindersCount }})
        </span>
      </div>
    </template>
    <template #content>
      <RemindersList :order-id="props.orderId" @update-reminders-count="setRemindersCount" />
    </template>
  </FormPanel>
</template>
